<template>
  <div>
    <input
      v-if="viewType !== 'infobar_disabled'"
      class="orm-input__control orm-km-input"
      id="kmDistance"
      type="text"
      name=""
      v-model="distance"
      @change="setDistance()"
      @keyup.enter="setDistance()"
    />
    <input
      v-if="viewType == 'infobar_disabled'"
      class="orm-input__control orm-km-input orm-km-input--disabled"
      id="kmDistance_disabled"
      type="text"
      name=""
      v-model="distance"
      disabled
    />
  </div>
</template>
<script>
import store from "@/store";
import i18n from "@/mixins/mixins";
import { slugMe } from "@/constants/formater";
import { buildDataLayer } from "@/constants/analytics";
export default {
  name: "KmInput",
  mixins: [i18n],
  data() {
    return {
      distance: 0,
    };
  },
  props: {
    viewType: String,
  },
  setup() {
    return {
      store,
    };
  },
  async created() {
    await this.loadCarGroup();
    buildDataLayer("view_item_list", {}, null);
    store.watch(
      (state, getters) => getters["reservation/GET_RESERVATION_DISTANCE"],
      (newValue) => {
        console.log("Drive Distance changed:", newValue);
        this.loadCarGroup();
      }
    );
  },

  async mounted() {
    this.distance = JSON.parse(
      store.getters["reservation/GET_RESERVATION_DISTANCE"]
    );
    document.querySelector("input").addEventListener("keypress", function(evt) {
      if (evt.which < 48 || evt.which > 57) {
        evt.preventDefault();
      }
    });
  },

  methods: {
    setDistance() {
      store.dispatch("reservation/SET_DRIVEDISTANCE", this.distance);

      console.log(
        "Drive Distance:",
        store.getters["reservation/GET_RESERVATION_DISTANCE"]
      );
      this.$emit("kmchange");
    },
    async loadCarGroup() {
      this.isLoading = true;
      this.stationSelected = await store.getters["userSession/GET_STATION"];
      this.carGroup = [];

      await store
        .dispatch("cargroup/GET_CARGROUP_FROM_STATION", this.stationSelected)
        .then((res) => {
          const object = res;
          for (const key in object) {
            if (Object.prototype.hasOwnProperty.call(object, key)) {
              const element = object[key];
              object.find((x) => x.id === element.id).price = [];
            }
          }
          this.carGroup = object;
          this.isLoading = false;
        });

      this.groupFilter = await store.getters["cargroup/GET_GROUPFILTER"];
      if (this.$route.params.name) {
        const kfzcategories = this.$route.params.name.split("+");
        if (kfzcategories.length > 1) {
          for (const key in kfzcategories) {
            if (Object.hasOwnProperty.call(kfzcategories, key)) {
              const kfzcategory = kfzcategories[key];
              if (
                this.groupFilter.find(
                  (element) => slugMe(element) == kfzcategory
                )
              ) {
                this.selectedGroup[
                  this.groupFilter.find(
                    (element) => slugMe(element) == kfzcategory
                  )
                ] = true;
              }
            }
          }
          store.dispatch("userSession/SET_CARCATEGORY", this.selectedGroup);
          this.selectedAll = false;
          this.selectwait = false;
        } else if (
          this.groupFilter.find(
            (element) => slugMe(element) == this.$route.params.name
          )
        ) {
          this.selectedGroup[
            this.groupFilter.find(
              (element) => slugMe(element) == this.$route.params.name
            )
          ] = true;
          store.dispatch("userSession/SET_CARCATEGORY", this.selectedGroup);
          this.selectedAll = false;
          this.selectwait = false;
        }
      } else {
        this.selectedGroup = await store.getters["userSession/GET_CARCATEGORY"];
        if (Object.keys(this.selectedGroup).length) {
          this.selectedAll = false;
        }
        this.selectwait = false;
      }
    },
  },
};
</script>

